import { useMutation } from "@tanstack/react-query";
import { useCustomerService } from "contexts/ServiceContext";
import useRefetchUserManagementQueries from "hooks/useRefetchUserManagementQueries";

const useEditUserPermissions = ({
  userId,
  ...userDetails
}: UserManagementDetails) => {
  const customerService = useCustomerService();
  const refetchUserManagement = useRefetchUserManagementQueries();
  return useMutation({
    mutationKey: ["user-management", "patch", { userId }],
    mutationFn: (permissions: UserPermissionsFlags) => {
      return userId
        ? customerService.updateUserPermissions(
            userId,
            userDetails,
            permissions
          )
        : Promise.reject();
    },
    onSuccess: refetchUserManagement,
  });
};

export default useEditUserPermissions;
